import x, { Component as q } from "react";
import S from "../../../../_virtual/isFunction.js";
import z from "../../../../_virtual/get.js";
import { clsx as E } from "../../../clsx/dist/clsx.js";
import { shallowEqual as L } from "../util/ShallowEqual.js";
import { Layer as R } from "../container/Layer.js";
import { Text as K } from "../component/Text.js";
import { Label as W } from "../component/Label.js";
import { isNumber as J } from "../util/DataUtils.js";
import { adaptEventsOfChild as Q } from "../util/types.js";
import { filterProps as T } from "../util/ReactUtils.js";
import { getTicks as X } from "./getTicks.js";
var Y = ["viewBox"], Z = ["viewBox"], H = ["ticks"];
function P(r) {
  "@babel/helpers - typeof";
  return P = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, P(r);
}
function _() {
  return _ = Object.assign ? Object.assign.bind() : function(r) {
    for (var t = 1; t < arguments.length; t++) {
      var i = arguments[t];
      for (var e in i)
        Object.prototype.hasOwnProperty.call(i, e) && (r[e] = i[e]);
    }
    return r;
  }, _.apply(this, arguments);
}
function $(r, t) {
  var i = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var e = Object.getOwnPropertySymbols(r);
    t && (e = e.filter(function(n) {
      return Object.getOwnPropertyDescriptor(r, n).enumerable;
    })), i.push.apply(i, e);
  }
  return i;
}
function u(r) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? $(Object(i), !0).forEach(function(e) {
      N(r, e, i[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(i)) : $(Object(i)).forEach(function(e) {
      Object.defineProperty(r, e, Object.getOwnPropertyDescriptor(i, e));
    });
  }
  return r;
}
function A(r, t) {
  if (r == null) return {};
  var i = ee(r, t), e, n;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(r);
    for (n = 0; n < a.length; n++)
      e = a[n], !(t.indexOf(e) >= 0) && Object.prototype.propertyIsEnumerable.call(r, e) && (i[e] = r[e]);
  }
  return i;
}
function ee(r, t) {
  if (r == null) return {};
  var i = {};
  for (var e in r)
    if (Object.prototype.hasOwnProperty.call(r, e)) {
      if (t.indexOf(e) >= 0) continue;
      i[e] = r[e];
    }
  return i;
}
function te(r, t) {
  if (!(r instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function D(r, t) {
  for (var i = 0; i < t.length; i++) {
    var e = t[i];
    e.enumerable = e.enumerable || !1, e.configurable = !0, "value" in e && (e.writable = !0), Object.defineProperty(r, M(e.key), e);
  }
}
function re(r, t, i) {
  return t && D(r.prototype, t), i && D(r, i), Object.defineProperty(r, "prototype", { writable: !1 }), r;
}
function ie(r, t, i) {
  return t = j(t), ne(r, I() ? Reflect.construct(t, i || [], j(r).constructor) : t.apply(r, i));
}
function ne(r, t) {
  if (t && (P(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return oe(r);
}
function oe(r) {
  if (r === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
function I() {
  try {
    var r = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (I = function() {
    return !!r;
  })();
}
function j(r) {
  return j = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(i) {
    return i.__proto__ || Object.getPrototypeOf(i);
  }, j(r);
}
function ae(r, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  r.prototype = Object.create(t && t.prototype, { constructor: { value: r, writable: !0, configurable: !0 } }), Object.defineProperty(r, "prototype", { writable: !1 }), t && C(r, t);
}
function C(r, t) {
  return C = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, n) {
    return e.__proto__ = n, e;
  }, C(r, t);
}
function N(r, t, i) {
  return t = M(t), t in r ? Object.defineProperty(r, t, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : r[t] = i, r;
}
function M(r) {
  var t = ce(r, "string");
  return P(t) == "symbol" ? t : t + "";
}
function ce(r, t) {
  if (P(r) != "object" || !r) return r;
  var i = r[Symbol.toPrimitive];
  if (i !== void 0) {
    var e = i.call(r, t);
    if (P(e) != "object") return e;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(r);
}
var F = /* @__PURE__ */ function(r) {
  function t(i) {
    var e;
    return te(this, t), e = ie(this, t, [i]), e.state = {
      fontSize: "",
      letterSpacing: ""
    }, e;
  }
  return ae(t, r), re(t, [{
    key: "shouldComponentUpdate",
    value: function(e, n) {
      var a = e.viewBox, o = A(e, Y), l = this.props, c = l.viewBox, v = A(l, Z);
      return !L(a, c) || !L(o, v) || !L(n, this.state);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var e = this.layerReference;
      if (e) {
        var n = e.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
        n && this.setState({
          fontSize: window.getComputedStyle(n).fontSize,
          letterSpacing: window.getComputedStyle(n).letterSpacing
        });
      }
    }
    /**
     * Calculate the coordinates of endpoints in ticks
     * @param  {Object} data The data of a simple tick
     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
     *  (x2, y2): The coordinate of endpoint close to axis
     */
  }, {
    key: "getTickLineCoord",
    value: function(e) {
      var n = this.props, a = n.x, o = n.y, l = n.width, c = n.height, v = n.orientation, k = n.tickSize, s = n.mirror, h = n.tickMargin, f, p, d, y, O, w, b = s ? -1 : 1, m = e.tickSize || k, g = J(e.tickCoord) ? e.tickCoord : e.coordinate;
      switch (v) {
        case "top":
          f = p = e.coordinate, y = o + +!s * c, d = y - b * m, w = d - b * h, O = g;
          break;
        case "left":
          d = y = e.coordinate, p = a + +!s * l, f = p - b * m, O = f - b * h, w = g;
          break;
        case "right":
          d = y = e.coordinate, p = a + +s * l, f = p + b * m, O = f + b * h, w = g;
          break;
        default:
          f = p = e.coordinate, y = o + +s * c, d = y + b * m, w = d + b * h, O = g;
          break;
      }
      return {
        line: {
          x1: f,
          y1: d,
          x2: p,
          y2: y
        },
        tick: {
          x: O,
          y: w
        }
      };
    }
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var e = this.props, n = e.orientation, a = e.mirror, o;
      switch (n) {
        case "left":
          o = a ? "start" : "end";
          break;
        case "right":
          o = a ? "end" : "start";
          break;
        default:
          o = "middle";
          break;
      }
      return o;
    }
  }, {
    key: "getTickVerticalAnchor",
    value: function() {
      var e = this.props, n = e.orientation, a = e.mirror, o = "end";
      switch (n) {
        case "left":
        case "right":
          o = "middle";
          break;
        case "top":
          o = a ? "start" : "end";
          break;
        default:
          o = a ? "end" : "start";
          break;
      }
      return o;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var e = this.props, n = e.x, a = e.y, o = e.width, l = e.height, c = e.orientation, v = e.mirror, k = e.axisLine, s = u(u(u({}, T(this.props, !1)), T(k, !1)), {}, {
        fill: "none"
      });
      if (c === "top" || c === "bottom") {
        var h = +(c === "top" && !v || c === "bottom" && v);
        s = u(u({}, s), {}, {
          x1: n,
          y1: a + h * l,
          x2: n + o,
          y2: a + h * l
        });
      } else {
        var f = +(c === "left" && !v || c === "right" && v);
        s = u(u({}, s), {}, {
          x1: n + f * o,
          y1: a,
          x2: n + f * o,
          y2: a + l
        });
      }
      return /* @__PURE__ */ x.createElement("line", _({}, s, {
        className: E("recharts-cartesian-axis-line", z(k, "className"))
      }));
    }
  }, {
    key: "renderTicks",
    value: (
      /**
       * render the ticks
       * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
       * @param {string} fontSize Fontsize to consider for tick spacing
       * @param {string} letterSpacing Letterspacing to consider for tick spacing
       * @return {ReactComponent} renderedTicks
       */
      function(e, n, a) {
        var o = this, l = this.props, c = l.tickLine, v = l.stroke, k = l.tick, s = l.tickFormatter, h = l.unit, f = X(u(u({}, this.props), {}, {
          ticks: e
        }), n, a), p = this.getTickTextAnchor(), d = this.getTickVerticalAnchor(), y = T(this.props, !1), O = T(k, !1), w = u(u({}, y), {}, {
          fill: "none"
        }, T(c, !1)), b = f.map(function(m, g) {
          var B = o.getTickLineCoord(m), V = B.line, G = B.tick, U = u(u(u(u({
            textAnchor: p,
            verticalAnchor: d
          }, y), {}, {
            stroke: "none",
            fill: v
          }, O), G), {}, {
            index: g,
            payload: m,
            visibleTicksCount: f.length,
            tickFormatter: s
          });
          return /* @__PURE__ */ x.createElement(R, _({
            className: "recharts-cartesian-axis-tick",
            key: "tick-".concat(m.value, "-").concat(m.coordinate, "-").concat(m.tickCoord)
          }, Q(o.props, m, g)), c && /* @__PURE__ */ x.createElement("line", _({}, w, V, {
            className: E("recharts-cartesian-axis-tick-line", z(c, "className"))
          })), k && t.renderTickItem(k, U, "".concat(S(s) ? s(m.value, g) : m.value).concat(h || "")));
        });
        return /* @__PURE__ */ x.createElement("g", {
          className: "recharts-cartesian-axis-ticks"
        }, b);
      }
    )
  }, {
    key: "render",
    value: function() {
      var e = this, n = this.props, a = n.axisLine, o = n.width, l = n.height, c = n.ticksGenerator, v = n.className, k = n.hide;
      if (k)
        return null;
      var s = this.props, h = s.ticks, f = A(s, H), p = h;
      return S(c) && (p = h && h.length > 0 ? c(this.props) : c(f)), o <= 0 || l <= 0 || !p || !p.length ? null : /* @__PURE__ */ x.createElement(R, {
        className: E("recharts-cartesian-axis", v),
        ref: function(y) {
          e.layerReference = y;
        }
      }, a && this.renderAxisLine(), this.renderTicks(p, this.state.fontSize, this.state.letterSpacing), W.renderCallByParent(this.props));
    }
  }], [{
    key: "renderTickItem",
    value: function(e, n, a) {
      var o;
      return /* @__PURE__ */ x.isValidElement(e) ? o = /* @__PURE__ */ x.cloneElement(e, n) : S(e) ? o = e(n) : o = /* @__PURE__ */ x.createElement(K, _({}, n, {
        className: "recharts-cartesian-axis-tick-value"
      }), a), o;
    }
  }]);
}(q);
N(F, "displayName", "CartesianAxis");
N(F, "defaultProps", {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  // The orientation of axis
  orientation: "bottom",
  // The ticks
  ticks: [],
  stroke: "#666",
  tickLine: !0,
  axisLine: !0,
  tick: !0,
  mirror: !1,
  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  tickMargin: 2,
  interval: "preserveEnd"
});
export {
  F as CartesianAxis
};
